import React, { Component } from 'react'
import { Button, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap'
import { closeModal } from '../../reducers/modals'
import { InitialOptions } from '../../participant/BaselineEvaluationConstants'

export default class UserContainer extends Component {
  constructor(props) {
    super(props)

    this.state = Object.assign(
      {
        firstName: '',
        lastName: '',
        email: '',
        assignedSectionId: null,
        trainerId: null,
        role: 3,
        completedOnboarding: false,
        username: '',
      },
      props.user || {}
    )
  }

  componentDidMount() {
    this._mounted = true
  }

  componentWillUnmount() {
    this._mounted = false
  }

  onCancel = () => {
    this.props.dispatch(closeModal())
  }

  onFinish = async () => {
    const { json, response } = await this.props.onSave(this.state)
    if (!this._mounted) return false
    if (response.status === 200) {
      this.props.dispatch(closeModal())
    } else {
      this.setState({ error: json.error })
    }
  }

  onDelete = async () => {
    if (!window.confirm('Are you sure you want to remove this user from the program?')) {
      return
    }
    const { json, response } = await this.props.onDelete(this.state)
    if (!this._mounted) return false
    if (response.status === 200) {
      this.props.dispatch(closeModal())
    } else {
      this.setState({ error: json.error })
    }
  }

  render() {
    const sections = this.props.sections
    const trainers = this.props.trainers
    const roles = [
      { id: 1, label: 'Admin' },
      { id: 2, label: 'Trainer' },
      { id: 3, label: 'User' },
    ]
    const { me } = this.props

    const verb = this.props.user ? 'Edit' : 'Create a'
    const {
      error,
      firstName,
      lastName,
      email,
      assignedSectionId,
      trainerId,
      role,
      completedOnboarding,
      goalSteps,
      username,
    } = this.state

    let valid = firstName && lastName && email && username

    return (
      <div className="UserModalContainer">
        <ModalHeader toggle={this.onCancel}>{verb} User</ModalHeader>
        <div className="row">
          <div className="col-md-12">
            <ModalBody>
              {error && <div className="alert alert-danger">{error}</div>}
              <Form>
                <FormGroup>
                  <div className="row">
                    <div className="col-md-4">
                      <Label for="firstName">First Name</Label>
                    </div>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        type="text"
                        id="firstName"
                        value={firstName}
                        onChange={(e) => this.setState({ firstName: e.target.value })}
                      />
                    </div>
                  </div>
                </FormGroup>

                <FormGroup>
                  <div className="row">
                    <div className="col-md-4">
                      <Label for="lastName">Last Name</Label>
                    </div>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        type="text"
                        id="lastName"
                        value={lastName}
                        onChange={(e) => this.setState({ lastName: e.target.value })}
                      />
                    </div>
                  </div>
                </FormGroup>

                <FormGroup>
                  <div className="row">
                    <div className="col-md-4">
                      <Label for="username">Username</Label>
                    </div>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        type="text"
                        id="username"
                        value={username === null ? '' : username}
                        onChange={(e) => this.setState({ username: e.target.value })}
                      />
                    </div>
                  </div>
                </FormGroup>

                <FormGroup>
                  <div className="row">
                    <div className="col-md-4">
                      <Label for="email">Email</Label>
                    </div>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        type="text"
                        id="email"
                        value={email}
                        onChange={(e) => this.setState({ email: e.target.value })}
                      />
                    </div>
                  </div>
                </FormGroup>

                <FormGroup>
                  <div className="row">
                    <div className="col-md-4">
                      <Label for="trainerId">Trainer</Label>
                    </div>
                    <div className="col-md-8">
                      <select
                        className="form-control"
                        id="trainerId"
                        value={trainerId === null ? 'none' : trainerId}
                        onChange={(e) =>
                          this.setState({
                            trainerId: e.target.value === 'none' ? null : e.target.value,
                          })
                        }
                      >
                        <option value={'none'}>None</option>
                        {trainers.map((s) => (
                          <option key={s.id} value={s.id}>
                            {s.firstName} {s.lastName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </FormGroup>

                {me.role === 1 ? (
                  <FormGroup>
                    <div className="row">
                      <div className="col-md-4">
                        <Label for="role">Role</Label>
                      </div>
                      <div className="col-md-8">
                        <select
                          className="form-control"
                          id="role"
                          value={role === null ? 3 : role}
                          onChange={(e) =>
                            this.setState({
                              role: e.target.value === 'none' ? null : e.target.value,
                            })
                          }
                        >
                          {roles.map((s) => (
                            <option key={s.id} value={s.id}>
                              {s.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </FormGroup>
                ) : null}

                <FormGroup>
                  <div className="row">
                    <div className="col-md-4">
                      <Label for="assignedSectionId">Section Assignment</Label>
                    </div>
                    <div className="col-md-8">
                      <select
                        className="form-control"
                        id="assignedSectionId"
                        value={assignedSectionId === null ? 'none' : assignedSectionId}
                        onChange={(e) =>
                          this.setState({
                            assignedSectionId: e.target.value === 'none' ? null : e.target.value,
                          })
                        }
                      >
                        <option value={'none'}>None</option>
                        {sections
                          .filter((s) => InitialOptions.includes(s.title))
                          .map((s) => (
                            <option key={s.id} value={s.id}>
                              {s.title}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                </FormGroup>

                <FormGroup>
                  <div className="row">
                    <div className="col-md-4">
                      <Label for="goalSteps">Daily Steps Goal</Label>
                    </div>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        type="number"
                        min={0}
                        max={20000}
                        id="goalSteps"
                        value={goalSteps}
                        onChange={(e) => this.setState({ goalSteps: e.target.value })}
                      />
                    </div>
                  </div>
                </FormGroup>

                <FormGroup>
                  <div className="row">
                    <div className="col-md-4">
                      <Label for="completedOnboarding">Completed Onboarding</Label>
                    </div>
                    <div className="col-md-8">
                      <input
                        type="checkbox"
                        id="completedOnboarding"
                        checked={completedOnboarding}
                        onChange={(e) => this.setState({ completedOnboarding: e.target.checked })}
                      />
                    </div>
                  </div>
                </FormGroup>
              </Form>
            </ModalBody>
          </div>
        </div>
        <ModalFooter>
          {this.props.onDelete && (
            <Button className="btn btn-danger" onClick={this.onDelete}>
              Delete
            </Button>
          )}
          {this.props.onDelete && <div style={{ flex: 1 }} />}
          <Button className="btn btn-primary" onClick={this.onFinish} disabled={!valid}>
            Save
          </Button>
        </ModalFooter>
      </div>
    )
  }
}
